import axios from 'axios';
import events from '../event-names';
import Config from '../../config';
import apiHeaders from '../../utils';


export function LoginUser (payload) {
    var payload = { ...payload };
    var options = {
        method: 'POST',
        withCredentials: true,
        // url: Config.apiRoot + '/check/valid/user/',
        url: Config.apiRoot + '/login',
        data: payload ,
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    };
    return {
        type: events.USER_LOGIN,
        payload: axios(options),
    }
};

export function Checklogin() {
    return (dispatch) => {
        dispatch({
            type: events.CHECK_LOGIN,
            payload: axios.get(`${Config.apiRoot}/checklogin`, { withCredentials: true }),
        }).then((response) => {
          

            // dispatch({
            //     meta: {language: 'dev'},
            //     type: events.TRANSLATION_FETCH,
            //     payload: axios.get([`${Config.translationFetchUrl}locales/Can5_Physician_Dashboard/dev/translation.json?`, Math.random()].join()),
            // });
            // dispatch({
            //     meta: {language: response.action.payload.data.language},
            //     type: events.TRANSLATION_FETCH,
            //     payload: axios.get([`${Config.translationFetchUrl}locales/Can5_Physician_Dashboard/${response.action.payload.data.language}/translation.json?`, Math.random()].join()),
            // });
        })
    };
}

export function LogoutAction() {
    return (dispatch) => {
        dispatch({
            type: events.LOGOUT,
            payload: axios.delete([Config.apiRoot, '/checklogin'].join(''), { withCredentials: true, ...apiHeaders() }),
        });
    };
}

export function getAvlLanguages() {
    return (dispatch) => {
        dispatch({
            type: events.GET_AVL_LANGUAGES,
            payload: axios.get([Config.apiRoot, '/languages'].join(''), { withCredentials: true, ...apiHeaders() }),
        });
    };
}

export function UserRegistration (payload) {
    var payload = { ...payload };
    var options = {
        method: 'POST',
        withCredentials: true,
        url: Config.apiRoot + '/user-registration',
        data: payload ,
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    };
    return {
        type: events.USER_REGISTRATION,
        payload: axios(options),
    }
};

export function SubmitUserRegOtp (payload) {
    var payload = { ...payload };
    var options = {
        method: 'POST',
        withCredentials: true,
        url: Config.apiRoot + '/otp/verify',
        data: payload ,
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    };
    return {
        type: events.SUBMIT_USER_REG_OTP,
        payload: axios(options),
    }
};

export function ResendRegOtp(payload) {
    return (dispatch) => {
        dispatch({
            type: events.RESEND_USER_REG_OTP,
            payload: axios.post([Config.apiRoot, '/otp/resend'].join(''), {...payload}, { withCredentials: true, ...apiHeaders() }),
        });
    };
}


export function ClearUserRegistration() {
    return {
        type: events.CLEAR_USER_REGISTRATION,
    }
};

export function ClearUserLogin() {
    return {
        type: events.CLEAR_USER_LOGIN,
    }
};

export function ResetPassword(payload) {
    return (dispatch) => {
        return dispatch({
            type: events.RESET_PASSWORD,
            payload: axios.post([Config.apiRoot, '/change/password'].join(''), payload, { withCredentials: true, ...apiHeaders() }),
        });
    };
}




